// B1319: the sub-route of the Access page, `#/access/<view>/<name>`. The
// name is URI-encoded in the hash, so a collection, role or user name with a
// space, a slash or a `%` survives the round trip.

export const ACCESS_VIEWS = ['collection', 'role', 'user'];

export function parseAccessSub(sub) {
  const s = String(sub ?? '');
  const slash = s.indexOf('/');
  const view = slash < 0 ? s : s.slice(0, slash);
  if (!ACCESS_VIEWS.includes(view)) return { view: 'collection', name: '' };
  const raw = slash < 0 ? '' : s.slice(slash + 1);
  let name = raw;
  try { name = decodeURIComponent(raw); } catch { /* a malformed escape: keep the text as-is */ }
  return { view, name };
}

export function accessHref(view, name) {
  return name ? `#/access/${view}/${encodeURIComponent(name)}` : `#/access/${view}`;
}
